import './CsvModal.scss'
import { useEffect, useState } from 'react'
import { Modal } from '../../Modals/Modal'
import CsvTable, { CsvTableSection } from './Table/CsvTable'
import { useTranslation } from 'react-i18next'
import { Slider } from '../../Slider/Slider'
import { useSettings } from '../../../../hooks/useSettings'

interface ICsvModalProps {
  onClose: () => void
  onPrint: () => void
  visible: boolean
  title?: string
  loading?: boolean
  className?: string

  /** Maximal count of columns in table */
  columnCount: number

  /** List of sections */
  sections: CsvTableSection[]
}

const CsvModal = (props: ICsvModalProps) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [displayedSections, setDisplayedSections] = useState<CsvTableSection[]>([])
  const [settings, updateSettings] = useSettings('orderDetails')

  useEffect(() => {
    if (props.visible) {
      setVisible(true)
    }
  }, [props.visible])

  useEffect(() => {
    setDisplayedSections([...props.sections])
  }, [props.sections])

  const onClose = () => {
    setVisible(false)

    const timeout = setTimeout(() => {
      props.onClose()
    }, 300)

    return () => clearTimeout(timeout)
  }

  const { t } = useTranslation()
  return (
    <Modal
      visible={visible}
      loading={props.loading}
      onClose={onClose}
      styles={{ maxWidth: 800, background: 'transparent', borderRadius: '20px 20px 0px 0px' }}
      hideCloseIcon
    >
      <div className={['csv-modal', props.className].join(' ')}>
        <div className="csv-modal-head">
          <div className="left">
            <div className="btn" onClick={onClose}>
              <i className="icon-left"></i> {t('BACK')}
            </div>
            <div className="csv-modal-title">{props.title}</div>
          </div>
          <div className="right">
            <Slider
              label={t('EMPTY_FIELDS')}
              labelPosition={'before'}
              checked={settings.showEmptyFields}
              onChange={() =>
                updateSettings({
                  showEmptyFields: !settings.showEmptyFields,
                })
              }
            ></Slider>
          </div>
        </div>
        <div className="csv-modal-body">
          <CsvTable
            columnCount={props.columnCount}
            sections={displayedSections}
            showEmptyFields={settings.showEmptyFields}
          />
        </div>
      </div>
    </Modal>
  )
}

export default CsvModal
